import Vue from 'vue';
import Router from 'vue-router';
import App from "../App";
import Main from "../components/Main";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      component: App
    },
    {
      path: '/',
      component: Main
    },
    {
      path: '/#dev-web',
      component: Main
    },
    {
      path: '/portfolio',
      component: Portfolio
    },
    {
      path: '/contact',
      component: Contact
    },
  ],
  scrollBehavior () {
    return {x: 0, y: 0}
  }
});
